import { render, staticRenderFns } from "./MRSignaturePrint.vue?vue&type=template&id=132b37be&scoped=true"
import script from "./MRSignaturePrint.vue?vue&type=script&lang=ts"
export * from "./MRSignaturePrint.vue?vue&type=script&lang=ts"
import style0 from "./MRSignaturePrint.vue?vue&type=style&index=0&id=132b37be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b37be",
  null
  
)

export default component.exports